import { t } from '../../i18n.es.js';
import { ProductPrice } from '@teko/teko-ecommerce';
import { EditOutlined } from '@teko/ds-icon';
import React from 'react';
import { styled, Body } from '@teko/ds-desktop';

const ProductPriceCart = ({ supplierRetailPrice, latestPrice, isPriceEditable, onEditPrice, className, align, isMobile = true, }) => {
    return (React.createElement("div", null,
        React.createElement(Wrapper, { className: className },
            React.createElement(ProductPrice, { supplierRetailPrice: supplierRetailPrice, latestPrice: latestPrice, textColor: "textPrimary", align: align }),
            isPriceEditable && isMobile && (React.createElement(StyledEditIcon, { onClick: onEditPrice, size: "1.25rem" }))),
        isPriceEditable && !isMobile && (React.createElement(EditPriceWrapper, null,
            React.createElement(StyledButtonChangePrice, { level: 1, color: "link500", hoverColor: "error500", onClick: onEditPrice }, t('Sửa giá'))))));
};
const Wrapper = styled.div `
  display: flex;
`;
const StyledEditIcon = styled(EditOutlined) `
  margin-left: 4px;
`;
const StyledButtonChangePrice = styled(Body) `
  margin-top: 4px;
  cursor: pointer;
`;
const EditPriceWrapper = styled.div `
  justify-content: flex-end;
  display: flex;
  line-height: 20px;
`;

export { ProductPriceCart };
